import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import SimpleSelectionTable, { SimpleFilterField } from 'components/datatable/SimpleSelectionTable'
import { normalizeString } from 'utils/StringUtil'

const HEADERS_CONTACTS = ['name', 'phoneTel', 'email', 'socialReason']

const DialogContacts = ({
    open= false,
    onClose = () => {},
    onValidate = () => {},

    contacts = [],
    selectedContacts = [],
    setSelectedContacts = () => {},
}) => {
    const filterFunction = (list, { searchValue = '' }) => {
        const searchValueFormat = normalizeString(searchValue)
        return searchValue ? list.filter(p => normalizeString(p.labelWithCode).includes(searchValueFormat)) : list
    }

    return (
        <Dialog open={open} maxWidth={'lg'}>
            <DefaultDialogTitle title={i18n.addContributor} onClose={onClose} />
            <DialogContent>
                <SimpleSelectionTable
                    listHeaders={HEADERS_CONTACTS}
                    listTitle={i18n.contactsList}
                    selectedListTitle={i18n.contactsSelected}

                    listData={contacts}
                    selectedList={selectedContacts}

                    onChange={setSelectedContacts}

                    filterField={SimpleFilterField}
                    filterFunction={filterFunction}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {i18n.close}
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogContacts.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    contacts: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        code: PropTypes.number,
        name: PropTypes.string,
        labelWithCode: PropTypes.string,
        title: PropTypes.string,
        socialReason: PropTypes.string,
        address: PropTypes.string,
        cityCode: PropTypes.string,
        phoneTel: PropTypes.string,
        phoneTelSecond: PropTypes.string,
        fax: PropTypes.string,
        desktopTel: PropTypes.string,
        mobile: PropTypes.string,
        email: PropTypes.string,
        bankCode: PropTypes.string,
        postalBox: PropTypes.string,
        townCode: PropTypes.string,
        localisation: PropTypes.shape({
            y: PropTypes.string,
            z: PropTypes.string,
        }),
        typeName: PropTypes.string,
    })),
    selectedContacts: PropTypes.arrayOf(PropTypes.number),
    setSelectedContacts: PropTypes.func,
}

export default DialogContacts